import Constant from '@/common/constant/Constant';

/**
 * Constants for the 翻訳管理 (Translation Management) screen.
 *
 * Status/usage code -> display label (JP literal) are wrapped with tr() at render
 * time, not here, so this file stays a pure code->code / code->literal map.
 */
const TranslationManagementConstant = {
    PAGE_SIZE: 50,

    // Sort fields accepted by the backend grid query.
    SORT_FIELD: {
        SOURCE_TEXT: 'sourceText',
        UPDATED_AT: 'updatedAt',
        CREATED_AT: 'createdAt'
    },
    SORT_ORDER: {
        ASC: 'asc',
        DESC: 'desc'
    },

    // 種別 (usage) options for the grid filter and the add dialogs. Mirrors the
    // persisted usages of TranslationDictionary.
    USAGE_OPTIONS: [
        Constant.TRANSLATION_USAGE.TAG,
        Constant.TRANSLATION_USAGE.UI,
        Constant.TRANSLATION_USAGE.FIELD_LABEL,
        Constant.TRANSLATION_USAGE.TERMINOLOGY
    ],

    // usage code -> JP label + CSS badge class (colors match the design mockup:
    // タグ=blue, 画面文言=pink/red, フィールド=green, 用語=purple).
    USAGE_META: {
        UI: { label: '画面文言', cls: 'tm-badge-ui' },
        FIELD_LABEL: { label: 'フィールド', cls: 'tm-badge-label' },
        TAG: { label: 'タグ', cls: 'tm-badge-tag' },
        TERMINOLOGY: { label: '用語', cls: 'tm-badge-term' }
    },

    // Row status (TranslationDictionary.status) -> JP label + CSS class.
    // Only the 4 statuses defined by the spec (§6.6): 自動 / 修正済 / 手動 / 未翻訳.
    STATUS_META: {
        AUTO: { label: '自動', cls: 'tm-st-auto' },
        CORRECTED: { label: '修正済', cls: 'tm-st-corrected' },
        MANUAL: { label: '手動', cls: 'tm-st-manual' },
        UNTRANSLATED: { label: '未翻訳', cls: 'tm-st-untranslated' }
    },

    // Server statuses outside the 4 spec statuses -> the spec status they are shown as.
    // IDENTICAL = the engine returned the source unchanged; it is still a machine
    // translation, so it is displayed as 自動.
    STATUS_DISPLAY_ALIAS: {
        IDENTICAL: 'AUTO'
    },

    // 状態 filter options shown in the toolbar (§8.6 / BR-30). 未翻訳 is display-only
    // (STATUS_META) and intentionally not filterable.
    STATUS_OPTIONS: ['AUTO', 'CORRECTED', 'MANUAL'],

    // Status values written by the server (TRANSLATION_DICTIONARY_STATUS).
    STATUS: {
        AUTO: 'AUTO',
        CORRECTED: 'CORRECTED',
        MANUAL: 'MANUAL'
    },

    // Header of the toggle column. Translated as ONE string; when shown in the source
    // language it breaks after the first LINE_BREAK_AT chars (コンテンツ / 翻訳に利用) per design.
    TERM_HEADER: {
        TEXT: 'コンテンツ翻訳に利用',
        LINE_BREAK_AT: 5
    },

    // 用語 filter values.
    TERM_FILTER: {
        ALL: '',
        ON: 'Y',
        OFF: 'N'
    },

    // Error codes of the inline 用語 row; the message is resolved (and translated) at
    // render time so it follows the dictionary once it loads.
    NEW_ROW_ERROR: {
        REQUIRED: 'REQUIRED',
        MAX_LENGTH: 'MAX_LENGTH',
        DUPLICATE: 'DUPLICATE',
        // VR-6: the Japanese translation is missing (keyword in another language).
        PIVOT_REQUIRED: 'PIVOT_REQUIRED',
        // VR-6: Japanese keyword without any other translation.
        TRANSLATION_REQUIRED: 'TRANSLATION_REQUIRED'
    },

    // Pivot language of every Terminology entry (glossary). Mirrors the backend
    // Translation.TRANSLATION_SOURCE_LANGUAGE.
    PIVOT_LANGUAGE: 'ja'
};

export default TranslationManagementConstant;
